export { default } from './ProductCalloutItem';
export type { CtaColor, Props as ProductCalloutItemProps } from './ProductCalloutItem';
